<template>
  <el-row style="height: 100%">
    <transition-group name="list" tag="p">
      <el-col
        v-for="mould in moulds"
        :key="mould.id"
        :md="6"
        :sm="12"
        :xs="12"
        :class="loose ? 'mould-detail-loose' : 'mould-detail'"
      >
        <div class="detail-wrapper" @click="goToDetails(mould)">
          <div class="mould-image-wrapper">
            <img
              v-lazy="mould.attachList[0].fileUrl"
              class="mould-image"
              :class="{ logo: isLogo }"
              :alt="mould.name"
            />
          </div>
          <div v-if="mould.name" class="mould-name">{{ mould.name }}</div>
          <el-tooltip
            v-if="mould.introduce"
            popper-class="mould-tooltip"
            :content="mould.introduce"
            placement="top"
          >
            <div class="mould-introduce">{{ mould.introduce }}</div>
          </el-tooltip>
        </div>
      </el-col>
    </transition-group>
  </el-row>
</template>

<script>
export default {
  name: "MouldExhibition",
  props: {
    moulds: Array,
    type: String,
    disable: {
      type: Boolean,
      default: false,
    },
    loose: {
      type: Boolean,
      default: false,
    },
    isLogo: Boolean,
  },
  methods: {
    showCustomerService() {
      this.$store.commit("showCustomerService");
    },
    goToDetails(mold) {
      if (!this.disable) {
        this.$router.push({
          path: `/product-detail/${mold.name
            .split(" ")
            .map((it) => it.toLowerCase())
            .join("-")}/${mold.id}`,
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
$--hover-shadow: 1px 1px 1px #eeeeee;
.full-category {
}

.category-introduce {
  position: absolute;
  left: 2rem;
  top: 3rem;
  color: white;
  font-size: 2rem;
  width: 80%;
  white-space: normal;
  text-align: left;
  font-weight: bold;
}

.mould-cover-image {
  max-height: 100%;
  max-width: 100%;
  &:hover {
    transition: all 100ms;
    box-shadow: $--hover-shadow;
    transform: translateY(-1px) translateX(-1px);
  }
}

.mould-image-wrapper {
  padding: 5% 0;

  .logo {
    width: auto;
    height: 100px;
  }
}

.mould-image {
  width: 100%;
  height: 12vw;
  object-fit: contain;
  border-radius: 5px;
}

.mould-detail {
  padding: 1px;
  height: 100%;
  div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.mould-detail-loose {
  @extend .mould-detail;
  padding: 5px;
}

.detail-wrapper {
  height: 100%;
  background-color: white;
  cursor: pointer;
  &:hover img {
    transform: translateY(-1px);
    transition: all 100ms;
    box-shadow: $--hover-shadow;
  }
}

.mould-name {
  font-size: 1.2rem;
  padding: 0px 1rem;
}

.mould-tooltip {
  font-size: 1.1rem !important;
}

.mould-introduce {
  font-size: 1rem;
  color: rgba(102, 102, 102, 1);
  padding: 4px 1.5rem;
  padding-bottom: 15px;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to
  /* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>
